import {
  DenkerLogo,
  Icons,
  surfaceRoleAttributes,
  surfaceRoleClassName,
} from "@/components/ui";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/cn";
import { useT } from "@/i18n";
import { authMessages } from "@/i18n/messages/auth";
import "./auth-liquid-glass.css";
import "./auth-transitions.css";

interface AuthPageLayoutProps {
  children: React.ReactNode;
  landingLink?: boolean;
  title?: string;
  /** Optional content rendered below the card, centered and width-matched
   * to it. Sits in the same flex column as the card and the landing link. */
  belowCard?: React.ReactNode;
}

export function AuthPageLayout({
  children,
  landingLink,
  title,
  belowCard,
}: AuthPageLayoutProps) {
  const t = useT(authMessages);
  return (
    <div className="auth-liquid-shell" data-testid="auth-layout">
      <div className="auth-layout-stack relative z-10">
        <div
          className={cn(
            surfaceRoleClassName("frame"),
            "auth-liquid-card relative w-full max-w-[430px]",
          )}
          data-testid="auth-card"
          {...surfaceRoleAttributes("frame")}
        >
          <div
            className="auth-brand-lockup relative z-10"
            data-testid="auth-logo"
          >
            <DenkerLogo variant="wordmark" color="black" height={30} />
          </div>

          <div className="auth-modal-content relative z-10">
            {title && (
              <h1 className="auth-page-title auth-form-title">{title}</h1>
            )}
            {children}
          </div>
        </div>

        {belowCard && <div className="w-full max-w-[430px]">{belowCard}</div>}

        {landingLink && (
          <a
            href="https://www.denker.ai"
            className={cn(
              buttonVariants({ variant: "ghost", size: "sm" }),
              "auth-small-link auth-back-button auth-landing-link",
            )}
            data-testid="back-to-landing-link"
          >
            <Icons.ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
            {t("backToLanding")}
          </a>
        )}
      </div>
    </div>
  );
}
